// extracted by mini-css-extract-plugin
export var active = "_ge-7";
export var blink = "_ge-8";
export var dropDownSelector = "_ge-4";
export var dropDownWrapper = "_ge-3";
export var fakeCursor = "_ge-6";
export var fontSizeButton = "_ge-9";
export var formQuillEditor = "_ge-0";
export var pressed = "_ge-a";
export var qlBlank = "_ge-1";
export var textFormattingToolbar = "_ge-2";
export var textToolbarOption = "_ge-5";